// extracted by mini-css-extract-plugin
export var createdDate = "_n5-1";
export var divider = "_n5-2";
export var headerDivider = "_n5-3";
export var messagesCard = "_n5-0";
export var messagesContainer = "_n5-7";
export var messagesContainerWrapper = "_n5-4";
export var pointerCapturingButtonBoxes = "_n5-a";
export var showLeftPanelButton = "_n5-9";
export var showMoreButton = "_n5-c";
export var showMoreButtonContainer = "_n5-b";
export var summaryTitle = "_n5-6";
export var systemMessageCardWrapper = "_n5-d";
export var topButtons = "_n5-8";
export var withPadding = "_n5-5";